import React from "react";
import PropTypes from "prop-types";
import ReactRouterPropTypes from "react-router-prop-types";
import { Button, Page } from "@dpdgroupuk/mydpd-ui";

import { COLLECTION_SEARCH } from "../../constants/strings";
import Footer from "../../components/Footer";
import NoResults from "../../components/NoResults";
import { useAuthUser } from "../../components/AuthUser";

const NoResultsView = ({ pageTitle, history }) => {
  const footer = React.useMemo(
    () => (
      <Footer>
        <Button onClick={history.goBack}>Back</Button>
      </Footer>
    ),
    [history]
  );
  const { username } = useAuthUser();
  return (
    <Page
      title={pageTitle}
      footer={footer}
      classNameBody="mx-auto"
      username={username}
    >
      <NoResults description={`You have no collections in your ${pageTitle}`} />
    </Page>
  );
};

NoResultsView.propTypes = {
  ...ReactRouterPropTypes,
  pageTitle: PropTypes.string,
};

NoResultsView.defaultProps = {
  pageTitle: COLLECTION_SEARCH,
};

export default NoResultsView;
